routes.$inject = [ '$stateProvider', '$urlRouterProvider', '$locationProvider' ]

import GlobalConfig from '../../../../globals/globalConfig.json'

export default function routes ($stateProvider, $urlRouterProvider, $locationProvider) {
	$locationProvider.html5Mode(true)
	$stateProvider
		.state('profile', {
			abstract  : false,
			url       : '/app/profile',
			redirectTo: 'profile.perfil_dash',
			views     : {
				'': {
					template: require('../../../../layout/layout.html'),
				},
				'content': {
					template: require('../../../../layout/content.html'),
				},
				'aside': {
					template  : require('../../../../layout/aside.html'),
					controller: 'AsideCtrl',
				},
				'header': {
					template  : require('../../../../layout/header.html'),
					controller: 'HeaderCtrl',
				},
				'footer': {
					template: require('../../../../layout/footer.html'),
				},
			},
		})
		.state('profile.perfil_dash', {
			abstract    : false,
			tag         : 'perfil_dash',
			url         : '/perfil_dash?teacherId',
			template    : require('./perfil_dash/perfil_dash.html'),
			controller  : 'perfildashController',
			controllerAs: 'perfildashVM',
			data        : {
				displayName: 'Perfil',
				title      : 'Perfil',
				order      : 0,
				siblings   : [
					{
						name        : 'profile.imprimir_hoja',
						rolesAllowed: [ GlobalConfig.userRolesIds.teacher ],
						order       : 1,
					},
					{
						name : 'profile.Actualizacion_Perfil',
						order: 2,
					},
				],
			},     
		})
		.state('profile.perfil_docente', {
			abstract    : false,
			tag         : 'perfil_docente',
			url         : '/perfil_docente/:teacherId',
			template    : require('./perfil_docente/perfil_docente.html'),
			controller  : 'perfildocenteController',
			controllerAs: 'perfildocenteVM',
			data        : {
				displayName: '',
				title      : 'Perfil Docente',
				order      : 1,
				siblings   : [
					{
						name : 'profile.perfil_dash',
						order: 0,
					},
					{
						name        : 'profile.imprimir_hoja',
						rolesAllowed: [ GlobalConfig.userRolesIds.teacher ],
						order       : 2,
					},
					{
						name : 'profile.Actualizacion_Perfil',
						order: 3,
					},
				],
			},
		})

		.state('profile.powerbi', {
			abstract    : false,
			tag         : 'Reporte',
			url         : '/perfilPowerbi',
			template    : require('./perfilPowerbi/powerbi.html'),
			controller  : 'powerbiPerfilCtrl',
			controllerAs: 'powerbiCtrl',  
			data        : {
				displayName: 'Reporte',
				title      : 'Reporte',
				order      : 0,
			},
  
		})

		.state('profile.perfil_investigation', {
			abstract    : false,
			tag         : 'perfil_investigation',
			url         : '/perfil_investigation/:teacherId',
			template    : require('./perfil_investigation/perfil_investigation.html'),
			controller  : 'Perfilinvestigationcontroller',
			controllerAs: 'Perfil',
			data        : {
				displayName: '',
				title      : 'Perfil de investigación',
				order      : 1,
				siblings   : [
					{
						name : 'profile.perfil_dash',
						order: 0,
					},
					{
						name        : 'profile.imprimir_hoja',
						rolesAllowed: [ GlobalConfig.userRolesIds.teacher ],
						order       : 2,
					},
					{
						name : 'profile.Actualizacion_Perfil',
						order: 3,
					},
				],
			},
		}) 
		.state('profile.perfil_extencion', {
			abstract    : false,
			tag         : 'perfil_extencion',
			url         : '/perfil_extencion/:teacherId',
			template    : require('./perfil_extencion/Perfil_de_Extension.html'),
			controller  : 'perfilextencioncotroller',
			controllerAs: 'Perfil',
			data        : {
				displayName: '',
				title      : 'Perfil de extensión',
				order      : 1,
				siblings   : [
					{
						name : 'profile.perfil_dash',
						order: 0,
					},
					{
						name        : 'profile.imprimir_hoja',
						rolesAllowed: [ GlobalConfig.userRolesIds.teacher ],
						order       : 2,
					},
					{
						name : 'profile.Actualizacion_Perfil',
						order: 3,
					},
				],
			},
		}) 
		.state('profile.UR_trajectory', {
			abstract    : false,
			tag         : 'UR_trajectory',
			url         : '/UR_trajectory/:teacherId',
			template    : require('./UR_trajectory/TrayectoriaUR.html'),
			controller  : 'trayectoriaurcontroller',
			controllerAs: 'Perfil',
			data        : {
				displayName: '',
				title      : 'Trayectoria UR',
				order      : 1,
				siblings   : [
					{
						name : 'profile.perfil_dash',
						order: 0,
					},
					{
						name        : 'profile.imprimir_hoja',
						rolesAllowed: [ GlobalConfig.userRolesIds.teacher ],
						order       : 2,
					},
					{
						name : 'profile.Actualizacion_Perfil',
						order: 3,
					},
				],
			},
		}) 
		.state('profile.perfilde_formacion', {
			abstract    : false,
			tag         : 'perfilde_formacion',
			url         : '/perfilde_formacion/:teacherId',
			template    : require('./perfilde_formacion/perfilformacion.html'),
			controller  : 'perfilformacioncontroller',
			controllerAs: 'Perfil',
			data        : {
				displayName: '',
				title      : 'Perfil de formación',
				order      : 1,
				siblings   : [
					{
						name : 'profile.perfil_dash',
						order: 0,
					},
					{
						name        : 'profile.imprimir_hoja',
						rolesAllowed: [ GlobalConfig.userRolesIds.teacher ],
						order       : 2,
					},
					{
						name : 'profile.Actualizacion_Perfil',
						order: 3,
					},
				],
			},
		}) 
		.state('profile.Reconocimientose_inc', {
			abstract    : false,
			tag         : 'Reconocimientose_inc',
			url         : '/Reconocimientose_inc/:teacherId',
			template    : require('./Reconocimientose_inc/Reconocimientos_e_inc.html'),
			controller  : 'Reconocimientose_incController',
			controllerAs: 'Perfil',
			data        : {
				displayName: '',
				title      : 'Reconocimientos e Inc.',
				order      : 1,
				siblings   : [
					{
						name : 'profile.perfil_dash',
						order: 0,
					},
					{
						name        : 'profile.imprimir_hoja',
						rolesAllowed: [ GlobalConfig.userRolesIds.teacher ],
						order       : 2,
					},
					{
						name : 'profile.Actualizacion_Perfil',
						order: 3,
					},
				],
			},
		}) 
		.state('profile.Trayectoria_Previa', {
			abstract    : false,
			tag         : '',
			url         : '/Trayectoria_Previa/:teacherId',
			template    : require('./Trayectoria_Previa/Trayectoria_Previa.html'),
			controller  : 'Trayectoria_PreviaCtrl',
			controllerAs: 'Perfil',
			data        : {
				displayName: '',
				title      : 'Trayectoria previa',
				order      : 1,
				siblings   : [
					{
						name : 'profile.perfil_dash',
						order: 0,
					},
					{
						name        : 'profile.imprimir_hoja',
						rolesAllowed: [ GlobalConfig.userRolesIds.teacher ],
						order       : 2,
					},
					{
						name : 'profile.Actualizacion_Perfil',
						order: 3,
					},
				],
			},
		}) 
		.state('profile.Actualizacion_Perfil', {
			abstract    : false,
			tag         : 'Actualizacion_Perfil',
			url         : '/Actualizacion_Perfil',
			template    : require('./Actualizacion_Perfil/Actualizacion_Perfil.html'),
			controller  : 'actualizacioncontroller',
			controllerAs: 'Perfil',
			data        : {
				displayName: 'Formulario de actualización',
				title      : 'Actualizacion de perfil',
				order      : 3,
				siblings   : [
					{
						name : 'profile.perfil_dash',
						order: 0,
					},
					{
						name        : 'profile.imprimir_hoja',
						rolesAllowed: [ GlobalConfig.userRolesIds.teacher ],
						order       : 2,
					},
				],
			},
		})   
		.state('profile.nueva_solicitud', {
			abstract    : false,
			tag         : 'nueva_solicitud',
			url         : '/nueva_solicitud',
			template    : require('./Actualizacion_Perfil/nueva_solicitud.html'),   
			controller  : 'newRequestCtrl',
			controllerAs: 'newReq',
			data        : {
				displayName: '',
				title      : 'Nueva solicitud',
				order      : 1,
				siblings   : [
					{
						name : 'profile.perfil_dash',
						order: 0,
					},
					{
						name        : 'profile.imprimir_hoja',
						rolesAllowed: [ GlobalConfig.userRolesIds.teacher ],
						order       : 2,
					},
					{
						name : 'profile.Actualizacion_Perfil',
						order: 3,
					},
				],
			},
		})    
		.state('profile.actualizacion_update', {
			abstract    : false,
			tag         : 'actualizacion_update',
			url         : '/actualizacion_update/:type/:stage?title&nTicket&historyType&idUser&nameUser&idTeacher',
			template    : require('./Actualizacion_Perfil/updateGenericTemplate.html'),
			controller  : 'updateDataProfileCtrl',
			controllerAs: 'updateVM',
			data        : {
				displayName: '',
				title      : 'Ver detalle',
				order      : 2,
				siblings   : [
					{
						name : 'profile.perfil_dash',
						order: 0,
					},
					{
						name        : 'profile.imprimir_hoja',
						rolesAllowed: [ GlobalConfig.userRolesIds.teacher ],
						order       : 1,
					},
				],
			},
		})  
		.state('profile.imprimir_hoja', {
			abstract    : false,
			tag         : 'imprimir_hoja',
			url         : '/imprimir_hoja',
			template    : require('./Actualizacion_Perfil/imprimir_hoja.html'),
			controller  : 'cvPrintCtrl',
			controllerAs: 'cvPrintVM',
			data        : { 
				displayName: 'Descargar hoja de vida',
				title      : 'Descargar hoja de vida',
				order      : 1,
				siblings   : [
					{
						name : 'profile.perfil_dash',
						order: 0,
					},
					{
						name : 'profile.Actualizacion_Perfil',
						order: 2,
					},
				],
			},  
		})
		.state('fullscreen.workflowMaintainer', {
			abstract    : false,
			tag         : 'workflowMaintainer',
			url         : '/workflowMaintainer',
			template    : require('./workflowMaintainer/workflowMaintainer.html'),
			controller  : 'workflowMaintainerCtrl',
			controllerAs: 'workflowMaintainerCtrl',
			data        : {
				displayName: '',
				title      : 'Matenedor de Flujos',
				order      : 0,
			},
		})                   
}



// WEBPACK FOOTER //
// ./src/app/u-faculty/profile/perfil/perfil.route.js